// extracted by mini-css-extract-plugin
export var closeButton = "_32-0";